<template>
  <section class="container-fluid my-4">
    <h4 class="my-4">Editando <strong>Aluno</strong></h4>

    <div v-if="student">

      <img
          src="@/assets/loading.gif"
          :alt="`Imagem do aluno: ${student.name}`"
          id="student-photo"
          class="zoom-on-hover"
          max-width="300px"
      />

      <form @submit.prevent="handlerSubmit" @reset="reset" ref="formStudent">
     
        <div class="row">
          <div class="col-md-6">

            <v-file-input
            v-bind:name="'image'"
            prepend-icon="mdi-camera"
            accept="image/*"
            label="Imagem do aluno"          
            ></v-file-input>

          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-2">
            <label for="status">Status</label>
            <div class="d-flex gap-2">
              <select 
                name="status" 
                v-model="student.status" 
                class="form-control"
                @change="updateStatus"
              >
                <option value="">-- Selecione --</option>
                <option 
                  v-for="option in statusOptions" 
                  :key="option.id" 
                  :value="option.id"
                >
                  {{ option.name }}
                </option>
              </select>
              <button 
                type="button"
                class="btn btn-sm btn-outline-secondary"
                @click="showStatusHistory"
                title="Ver histórico de status"
              >
                <font-awesome-icon icon="history" />
              </button>
            </div>
          </div>
          <div class="form-group col-md-4">
            <label for="name">Nome</label>
            <input
              type="text"
              class="form-control"
              name="name"
              v-model="student.name"
            />
          </div>
          <div class="form-group col-md-2">
            <label for="gender">Gênero</label>
            <select name="gender" v-model="student.gender" class="form-control">
              <option disabled value="">-- Selecione --</option>
              <option value="F">F</option>
              <option value="M">M</option>
            </select>
          </div>
          <div class="form-group col-md-6">
            <label for="email">E-mail</label>
            <input
              type="email"
              name="email"
              class="form-control"
              id="email"
              v-model="student.email"
            />
          </div>
          <div class="form-group col-md-6">
            <label for="financial_responsible_id">Responsável Financeiro</label>
            <div class="d-flex gap-2">
              <select
                name="financial_responsible_id"
                v-model="student.financial_responsible_id"
                class="form-control"
              >
                <option value="">-- Nenhum --</option>
                <option
                  v-for="responsible in financialResponsibles"
                  :key="responsible.id"
                  :value="responsible.id"
                >
                  {{ responsible.name }} - {{ responsible.cpf }}
                </option>
              </select>
              <button
                type="button"
                class="btn btn-sm btn-success"
                @click="showModalFinancialResponsible"
                title="Adicionar novo responsável"
              >
                <font-awesome-icon icon="plus" />
              </button>
              <button
                type="button"
                class="btn btn-sm btn-primary"
                @click="editFinancialResponsible"
                :disabled="!student.financial_responsible_id"
                title="Editar responsável selecionado"
              >
                <font-awesome-icon icon="edit" />
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <div class="form-check mt-2">
              <input
                class="form-check-input"
                type="checkbox"
                name="has_punctuality_discount"
                id="has_punctuality_discount"
                v-model="student.has_punctuality_discount"
                :true-value="1"
                :false-value="0"
              />
              <label class="form-check-label" for="has_punctuality_discount">
                Desconto por pontualidade (mensalidade)
              </label>
            </div>
          </div>
          <div class="form-group col-md-3" v-if="student.has_punctuality_discount">
            <label for="punctuality_discount_amount">Valor do desconto</label>
            <input
              type="text"
              class="form-control"
              name="punctuality_discount_amount"
              id="punctuality_discount_amount"
              v-model="student.punctuality_discount_amount"
              placeholder="0,00"
            />
          </div>
        </div>

        <div class="row">

          <div class="form-group col-md-4">
            <label for="name">Endereço</label>
            <input
              type="text"
              class="form-control"
              name="street"
              v-model="student.street"
            />
          </div>

          <div class="form-group col-md-2">
            <label for="name">Número</label>
            <input
              type="text"
              class="form-control"
              name="number"
              v-model="student.number"
            />
          </div>

          <div class="form-group col-md-1">
            <label for="name">CEP</label>
            <input 
                maxlength="8"
                type="text"
                class="form-control" 
                name="cep"
                v-model="student.cep"
                @blur="zipCodeQuery"
            />
          </div>
          <div class="form-group col-md-1">
            <label for="name">Bairro</label>
            <input
              type="text"
              class="form-control"
              name="neighborhood"
              v-model="student.neighborhood"
            />
          </div>
          <div class="form-group col-md-2">
            <label for="name">Cidade</label>
            <input
              type="text"
              class="form-control"
              name="city"
              v-model="student.city"
            />
          </div>
          <div class="form-group col-md-2">
            <label for="name">Estado</label>
            <input
              type="text"
              class="form-control"
              name="uf"
              v-model="student.uf"
            />
          </div>

          </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="phone">Telefone</label>
            <div class="d-flex gap-2">
              <TheMask
                type="text"
                name="phone"
                class="form-control"
                :mask="['(##)#####-#####']"
                v-model="student.phone"
                :masked="true"
              />
              <button
                type="button"
                class="btn btn-sm btn-success"
                @click="openWhatsApp"
                :disabled="!student.phone"
                title="Abrir conversa no WhatsApp"
              >
                <font-awesome-icon :icon="['fab', 'whatsapp']" />
              </button>
            </div>
          </div>
          <div class="form-group col-md-6">
            <label for="cpf">Cpf</label>
            <TheMask
              type="text"
              name="cpf"
              class="form-control"
              :mask="['###.###.###-##']"
              v-model="student.cpf"
            />
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="rg">RG</label>
            <input
              type="text"
              class="form-control"
              id="rg"
              name="rg"
              v-model="student.rg"
            />
          </div>
          <div class="form-group col-md-6">
            <label for="expedient_body">Orgão expedidor</label>
            <input
              type="text"
              name="expedient_body"
              class="form-control"
              id="expedient_body"
              v-model="student.expedient_body"
            />
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="nationality">Nacionalidade</label>
            <input
              type="text"
              name="nationality"
              class="form-control"
              v-model="student.nationality"
            />
          </div>
          <div class="form-group col-md-6">
            <label for="naturalness">Naturalidade</label>
            <input
              type="text"
              name="naturalness"
              class="form-control"
              id="naturalness"
              v-model="student.naturalness"
            />
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="birth_date">Data de nascimento</label>
            <input
              type="date"
              name="birth_date"
              class="form-control"
              v-model="student.birth_date"
            />
           <small class="text-secondary"> {{ student.age }}</small>
          </div>
          <div class="form-group col-md-6">
            <label for="name_mother">Nome da mãe</label>
            <input
              type="text"
              name="name_mother"
              class="form-control"
              v-model="student.name_mother"
            />
          </div>
        </div>

        <div class="form-group text-center my-2">
          <button type="submit" class="btn btn-success btn-sm mx-2">
            SALVAR
          </button>
          <button type="reset" class="btn btn-secondary btn-sm">LIMPAR</button>
        </div>
      </form>

      <!-- //? Novo processo de matricular -->

      <div class="row">
        <div class="col-md-12">
          <v-card>
            <v-tabs
              v-model="activeTab"
              color="deep-blue accent-4"
            >
              <v-tab>MATRÍCULAS</v-tab>
              <v-tab>FINANCEIRO</v-tab>
              <v-tab>DOCUMENTOS</v-tab>
              <v-tab>LIVROS</v-tab>
              <v-tab>OBSERVAÇÕES</v-tab>
              <v-tab>ACOMPANHAMENTO DE ENVIO</v-tab>

              <v-tab-item>
                <div class="p-2">

                  <div class="row my-2">
                    <div class="col-md-2">
                      <!-- //? Matricular -->
                      <form @submit.prevent="handlerRegistration">
                        <div class="mb-3">
                          <SearchableSelect
                            v-model="teamRegistration"
                            :options="teams"
                            item-text="name"
                            item-value="id"
                            label="Turma"
                            placeholder="-- Selecione --"
                          />
                        </div>
                        <button
                          type="submit"
                          class="btn btn-success btn-sm text-uppercase"
                        >
                          Matricular
                        </button>
                      </form>
                    </div>

                    <div v-if="!!hasRegistration.length" class="col-md-10">
                      <small>Turmas em que o aluno está matriculado:</small>
                      <ul class="list-group">
                        <li
                          v-for="(registration, key) in student.registrations"
                          :key="key"
                          class="align-items-center grids-for-contracts"
                        >
                          <router-link
                            :to="{
                              name: 'team-edit',
                              params: { id: registration.team.id },
                            }"
                            class="btn btn-sm btn-outline-primary"
                            :title="`${registration.user.name} - ${registration.created_at}`"
                          >
                            {{ String(registration.id).padStart(6, "0") }} |
                            {{ registration.team.name | uppercase }}
                          </router-link>

                          <a v-if="registration.file_url_contract" class="btn btn-sm btn-light" :href='registration.file_url_contract' target="_blank">
                            <font-awesome-icon icon="download" />
                              <small class="text-muted"> CTR-{{registration.id}}-{{student.id}}-{{registration.team.id}} </small>
                              CONTRATO
                          </a>
                          <span href="#" v-else disabled class="text-muted text-center">
                            CONTRATO AUSENTE <font-awesome-icon icon="arrow-right" />
                          </span>

                          <a href="#" class="btn btn-sm btn-light" @click="generateContract(registration.student.id, registration.team.id)">
                            <font-awesome-icon icon="play" /> 
                            <span v-if="registration.file_url_contract"> ATUALIZAR</span>
                            <span v-else> GERAR</span>
                          </a>

                          <a 
                            href="#" 
                            class="btn btn-sm btn-light" 
                            :class="{ 'disabled': !registration.file_url_contract }"
                            :disabled="!registration.file_url_contract"
                            @click="registration.file_url_contract ? generateContractAdditiveTerm(registration.student.id, registration.team.id) : null"
                            :title="!registration.file_url_contract ? 'Contrato necessário para rematrícula' : 'Realizar rematrícula'"
                          >
                          <font-awesome-icon icon="redo" v-if="registration.file_url_contract_additive_term" />
                          <font-awesome-icon icon="play" v-else /> 
                            <span> REMATRÍCULA</span>
                          </a>

                          <a 
                            :class="{ 'disabled': !registration.file_url_contract_additive_term }"
                            class="btn btn-sm btn-light" 
                            :href='registration.file_url_contract_additive_term' 
                            target="_blank">
                            <font-awesome-icon icon="download" />
                              CONTRATO (REMATRÍCULA)
                          </a>

                          <div class="d-flex align-items-center gap-2 mt-1">
                            <small class="text-muted">SISTEC:</small>
                            <input
                              type="text"
                              class="form-control form-control-sm"
                              style="max-width:160px"
                              v-model="registration.sistec_number"
                              placeholder="Nº SISTEC"
                              @blur="updateRegistrationSistec(registration)"
                            />
                          </div>
                          <ButtonDelete @delete=" handlerDelete(registration.id, 'registrations')" />
                        </li>
                      </ul>
                    </div>

                    <div class="col-md-6" v-else>
                      <div class="alert alert-warning" role="alert">
                        Não há matrícula registrada para este aluno.
                      </div>
                    </div>
                  </div>

                </div>
              </v-tab-item>
              <v-tab-item>
                <div class="p-2">
                  
                  <br />

                  <div class="accordion" id="accordionFinancial">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingTableFinancial">
                        <button
                          class="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTableFinancial"
                          aria-expanded="true"
                          aria-controls="collapseTableFinancial"
                        >
                          Pendências Financeira
                        </button>
                      </h2>
                      <div
                        id="collapseTableFinancial"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingTableFinancial"
                        data-bs-parent="#accordionFinancial"
                      >
                        <div class="accordion-body">
                          <div class="row my-2 p-2">
                              <hr/>
                              <div class="d-flex align-items-center mb-2 gap-3">
                                <div>
                                  <label for="filterPaid" class="me-2 mb-0">Filtrar Status:</label>
                                  <select id="filterPaid" v-model="filterPaid" class="form-control form-control-sm w-auto">
                                    <option value="">Todos</option>
                                    <option value="paid">Pago</option>
                                    <option value="overdue">Vencido</option>
                                    <option value="upcoming">A Vencer</option>
                                  </select>
                                </div>
                                <div>
                                  <label for="filterTeam" class="me-2 mb-0">Filtrar Por Turma:</label>
                                  <select id="filterTeam" v-model="filterTeam" class="form-control form-control-sm w-auto">
                                    <option value="">Todas</option>
                                    <option v-for="registration in hasRegistration" :key="registration.team.id" :value="String(registration.team.id)">
                                      {{ registration.team.name | uppercase }}
                                    </option>
                                  </select>
                                </div>
                                <div>
                                  <label for="serviceTypeFilter" class="me-2 mb-0">Filtrar Tipo de Serviço:</label>
                                  <select id="serviceTypeFilter" v-model="serviceTypeFilter" class="form-control form-control-sm w-auto">
                                    <option value="">Todos</option>
                                    <option v-for="service in serviceTypes" :key="service.id" :value="String(service.id)">
                                      {{ service.name }}
                                    </option>
                                  </select>
                                </div>
                                <div>
                                  <label for="filterParcelId" class="me-2 mb-0">Pesquisar ID da Parcela:</label>
                                  <input id="filterParcelId" v-model="filterParcelId" class="form-control form-control-sm w-auto" placeholder="ID da parcela" />
                                </div>
                                <div>
                                  <label for="filterFinancialObservation" class="me-2 mb-0">Pesquisar Observação Financeira:</label>
                                  <input id="filterFinancialObservation" v-model="filterFinancialObservation" class="form-control form-control-sm w-auto" placeholder="Observação financeira" />
                                </div>
                              </div>
                            <hr/>
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              <small class="p-0"
                                >Situação financeira do aluno:
                                <a
                                  href="#"
                                  class="text-primary"
                                  @click.prevent="generateStatement"
                                  ><u>🧾 EXTRATO FINANCEIRO</u></a
                                ></small
                              >
                              
                              <v-btn
                                color="primary"
                                small
                                :disabled="selectedFinancials.length === 0"
                                @click="openRenegotiateModal"
                              >
                                <v-icon left small>mdi-handshake</v-icon>
                                Negociar Parcelas ({{ selectedFinancials.length }})
                              </v-btn>
                            </div>

                            <v-data-table
                              v-model="selectedFinancials"
                              :headers="financialHeaders"
                              :items="filteredFinancials"
                              :items-per-page="-1"
                              :footer-props="{
                                'items-per-page-text': 'Linhas por página:',
                                'items-per-page-all-text': 'Todos',
                                'page-text': '{0}-{1} de {2}'
                              }"
                              show-select
                              :single-select="false"
                              item-key="id"
                              class="elevation-1"
                            >
                              <!-- Slot para ID formatado -->
                              <template v-slot:[`item.registration_id`]="{ item }">
                                {{ String(item.registration_id).padStart(6, '0') }}
                              </template>

                              <!-- Slot para Turma formatada -->
                              <template v-slot:[`item.team_name`]="{ item }">
                                <router-link :to="{ name: 'team-edit', params: { id: item.team_id } }" target="_blank" class="text-decoration-none">
                                  {{ item.team_name | uppercase }}
                                </router-link>
                              </template>

                              <!-- Slot para valor formatado -->
                              <template v-slot:[`item.value`]="{ item }">
                                {{ item.value | currency }}
                              </template>

                              <template v-slot:[`item.punctuality_discount`]="{ item }">
                                {{ (item.punctuality_discount || 0) | currency }}
                              </template>

                              <template v-slot:[`item.fine`]="{ item }">
                                {{ (item.fine || 0) | currency }}
                              </template>

                              <template v-slot:[`item.interest`]="{ item }">
                                {{ (item.interest || 0) | currency }}
                              </template>

                              <template v-slot:[`item.total`]="{ item }">
                                {{ (item.total != null ? item.total : item.value) | currency }}
                              </template>

                              <!-- Slot para status de pagamento -->
                              <template v-slot:[`item.paid`]="{ item }">
                                <v-chip 
                                  :color="getPaymentStatusColor(item)" 
                                  small 
                                  dark
                                >
                                  {{ getPaymentStatusText(item) }}
                                </v-chip>
                              </template>

                              <!-- Slot para usuário atualizador -->
                              <template v-slot:[`item.updated_user.name`]="{ item }">
                                <span v-if="item.updated_user">{{ item.updated_user.name }}</span>
                                <span v-else class="text-muted">-</span>
                              </template>

                              <!-- Slot para usuário da baixa -->
                              <template v-slot:[`item.paid_by_user.name`]="{ item }">
                                <span v-if="item.paid_by_user">{{ item.paid_by_user.name }}</span>
                                <span v-else class="text-muted">-</span>
                              </template>

                              <!-- Slot para ações -->
                              <template v-slot:[`item.actions`]="{ item }">
                                <button class="btn btn-outline-primary btn-sm me-1" @click="showModalFinancial(item.id, item.payment_type)">
                                  <font-awesome-icon icon="edit" />
                                </button>
                                <button class="btn btn-outline-secondary btn-sm me-1" @click="showReceiptEmissions(item.id)" title="Histórico de emissões do recibo">
                                  <font-awesome-icon icon="history" />
                                </button>
                                <ButtonDelete @delete="handlerDelete(item.id, 'financials')" />
                              </template>

                              <!-- Desabilitar seleção de parcelas já pagas -->
                              <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
                                <v-simple-checkbox
                                  :value="isSelected"
                                  @input="select($event)"
                                  :disabled="!!item.paid"
                                  :ripple="false"
                                ></v-simple-checkbox>
                              </template>
                            </v-data-table>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="accordion-item">
                      <h2 class="accordion-header" id="headingAddFinancial">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseAddFinancial"
                          aria-expanded="false"
                          aria-controls="collapseAddFinancial"
                        >
                          Adicionar Financeiro
                        </button>
                      </h2>
                      <div
                        id="collapseAddFinancial"
                        class="accordion-collapse collapse show"
                        aria-labelledby="headingAddFinancial"
                        data-bs-parent="#accordionFinancial"
                      >
                        <div class="accordion-body">
                          <div class="row my-2">
                            <div class="col-md-12">
                              <form
                                ref="formFinancial"
                                @submit.prevent="handlerFinancial"
                                class="row"
                                @reset="reset"
                              >
                                <div class="mb-3 col-md-2">
                                  <label for="registration" class="form-label"
                                    >Nº de matrícula</label
                                  >
                                  <select
                                    v-if="!!hasRegistration.length"
                                    name="registration_id"
                                    class="form-control form-control-sm"
                                  >
                                    <option value="" selected disabled>
                                      -- Selecione --
                                    </option>
                                    <option
                                      v-for="(
                                        registration, key
                                      ) in student.registrations"
                                      :key="key"
                                      :value="registration.id"
                                    >
                                      {{
                                        String(registration.id).padStart(6, "0")
                                      }}
                                      - {{ registration.team.name | uppercase }}
                                    </option>
                                  </select>
                                </div>

                                <div class="mb-3 col-md-1">
                                  <label for="value" class="form-label"
                                    >Parcela</label
                                  >
                                  <input
                                    @keyup="filterNonNumeric"
                                    type="number"
                                    class="form-control form-control-sm"
                                    name="quota"
                                  />
                                </div>

                                <div class="mb-3 col-md-1">
                                  <label for="value" class="form-label"
                                    >Valor</label
                                  >
                                  <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    name="value"
                                    placeholder="0,00"
                                    data-thousands="."
                                    data-decimal=","
                                  />
                                </div>

                                <div class="mb-3 col-md-2">
                                  <label for="due_date" class="form-label"
                                    >Vencimento</label
                                  >
                                  <input
                                    type="date"
                                    class="form-control form-control-sm"
                                    name="due_date"
                                  />
                                </div>

                                <div class="mb-3 col-md-1">
                                  <label for="paid" class="form-label"
                                    >Quitado</label
                                  >
                                  <select
                                    name="paid"
                                    class="form-control form-control-sm"
                                  >
                                    <option value="" selected disabled>--</option>
                                    <option value="0">NÃO</option>
                                    <option value="1">SIM</option>
                                  </select>
                                </div>

                                <div class="mb-3 col-md-2">
                                  <label for="service_type_id" class="form-label"
                                    >Tipo de Serviço</label
                                  >
                                  <select
                                    name="service_type_id"
                                    class="form-control form-control-sm"
                                  >
                                    <option value="" selected disabled>
                                      -- Selecione --
                                    </option>
                                    <option
                                      v-for="(service, key) in serviceTypes"
                                      :key="key"
                                      :value="service.id"
                                    >
                                      {{ service.name | uppercase }}
                                    </option>
                                  </select>
                                </div>
                                <div class="mb-3 col-md-2">
                                  <label for="payment_type" class="form-label"
                                    >Forma de Pagamento</label
                                  >
                                  <select
                                    name="payment_type"
                                    class="form-control form-control-sm"
                                  >
                                    <option value="" selected disabled>
                                      -- Selecione --
                                    </option>
                                    <option
                                      v-for="(payment, key) in paymentTypes"
                                      :key="key"
                                      :value="payment.id"
                                    >
                                      {{ payment.name | uppercase }}
                                    </option>
                                  </select>
                                </div>

                                <div class="mb-3 col-md-1">
                                  <label for="observations" class="form-label"
                                    >Observação</label
                                  >
                                  <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    name="observations"
                                  />
                                </div>

                                <div
                                  class="col-md-12 d-flex justify-content-between"
                                >
                                  <div class="d-flex">
                                    <button
                                      type="submit"
                                      title="Informe no campo à direita a quantidade de repetições desta ação."
                                      class="btn btn-success btn-sm text-uppercase"
                                    >
                                      Criar <font-awesome-icon icon="question" />
                                    </button>
                                    <input
                                      @keyup="filterNonNumeric"
                                      type="text"
                                      name="numberOfTimesToEnter"
                                      v-model="numberOfTimesToEnter"
                                      class="form-control form-control-sm ms-2 w-25"
                                    />
                                  </div>
                                  <button
                                    type="reset"
                                    class="btn btn-secondary btn-sm text-uppercase"
                                  >
                                    Limpar
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Seção: Minutas de Acordos -->
                  <div class="row my-4">
                    <div class="col-md-12">
                      <h6 class="mb-3">Minutas de Acordos</h6>
                      
                      <div v-if="agreementDrafts.length > 0">
                        <div class="table-responsive">
                          <table class="table table-bordered table-sm">
                            <thead class="table-light">
                              <tr>
                                <th>Nome do Arquivo</th>
                                <th>Tamanho</th>
                                <th>Data de Criação</th>
                                <th>Ações</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="draft in agreementDrafts" :key="draft.name">
                                <td>{{ draft.name }}</td>
                                <td>{{ draft.size_formatted }}</td>
                                <td>{{ draft.created_at }}</td>
                                <td>
                                  <a 
                                    :href="draft.url" 
                                    target="_blank"
                                    class="btn btn-sm btn-outline-primary"
                                    title="Baixar Minuta"
                                  >
                                    <font-awesome-icon icon="download" /> Baixar
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      
                      <div v-else class="alert alert-info" role="alert">
                        <font-awesome-icon icon="info-circle" /> 
                        Nenhuma minuta de acordo encontrada para este aluno.
                      </div>
                    </div>
                  </div>

                </div>
              </v-tab-item>
              <v-tab-item>
                <div class="p-2">
                  
                  <div class="row my-2">
                    <div class="col-md-3">
                      <div class="d-grid gap-2 col-12 mx-auto">
                        <router-link
                          :to="{
                            name: 'history-register',
                            params: { student: student.id },
                          }"
                          class="btn btn-outline-primary btn-sm"
                          type="button"
                          >GERAR HISTÓRICO</router-link
                        >
                        <router-link
                          :to="{
                            name: 'certificate-register',
                            params: { student: student.id },
                          }"
                          class="btn btn-outline-primary btn-sm"
                          type="button"
                          >GERAR CERTIFICADO</router-link
                        >
                      </div>
                    </div>
                    <div class="col-md-9">
                      <!-- //? Documentos -->
                      <small class="p-0"
                        >Documentos emitidos para o aluno até o momento:</small
                      >
                      <div class="doc-thumbs-grid" v-if="!!hasDocuments.length">
                        <div
                          v-for="(document, key) in student.documents"
                          :key="key"
                          class="doc-thumb-card"
                        >
                          <div
                            class="doc-thumb-preview"
                            @click.prevent="getBlob(document)"
                            :title="`Baixar: ${document.file_name}`"
                          >
                            <iframe
                              v-if="documentPreviews[document.id]"
                              :src="documentPreviews[document.id] + '#toolbar=0&navpanes=0&scrollbar=0'"
                              class="doc-thumb-iframe"
                              scrolling="no"
                              frameborder="0"
                            ></iframe>
                            <div v-else class="doc-thumb-placeholder">
                              <i class="ti ti-file-type-pdf"></i>
                              <span>PDF</span>
                            </div>
                          </div>
                          <div class="doc-thumb-footer">
                            <span class="doc-thumb-name" :title="document.file_name + ' - ' + document.created_at">
                              {{ document.file_name }}
                            </span>
                            <span class="doc-thumb-date">{{ document.created_at }}</span>
                            <div class="doc-thumb-actions">
                              <button @click.prevent="getBlob(document)" class="btn btn-xs btn-outline-primary" title="Baixar">
                                <font-awesome-icon icon="download" />
                              </button>
                              <a href="#" class="btn btn-xs btn-outline-danger" @click.prevent="destroyPDF(document)" title="Excluir">
                                <font-awesome-icon icon="trash" />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </v-tab-item>
              <v-tab-item>
                <div class="p-2">
                  
                  <div class="row my-2">
                    <div class="col-md-4">
                      <form ref="formBook" @submit.prevent="handlerCreateBook">
                        <div class="mb-3">
                          <label for="team" class="form-label">Turma</label>
                          <select
                            name="team_id"
                            class="form-control form-control-sm"
                          >
                            <option value="" selected disabled>
                              -- Selecione --
                            </option>
                            <option
                              v-for="(team, key) in teams"
                              :key="key"
                              :value="team.id"
                            >
                              {{ team.name | uppercase }}
                            </option>
                          </select>
                        </div>
                        <div class="mb-3">
                          <label for="book_type" class="form-label">Tipo de Livro</label>
                          <select
                            name="book_type_id"
                            class="form-control form-control-sm"
                          >
                            <option value="" selected disabled>
                              -- Selecione --
                            </option>
                            <option
                              v-for="(bookType, key) in bookTypes"
                              :key="key"
                              :value="bookType.id"
                            >
                              {{ bookType.name }}
                            </option>
                          </select>
                        </div>
                        <div class="row mb-3">
                          <div class="col-md-6 mb-3">
                            <input
                              placeholder="N.º de Registro"
                              type="text"
                              class="form-control form-control-sm"
                              name="registration_number"
                            />
                          </div>
                          <div class="col-md-6 mb-3">
                            <input
                              placeholder="N.º do Livro"
                              type="text"
                              class="form-control form-control-sm"
                              name="book_number"
                            />
                          </div>
                          <div class="col-md-6 mb-3">
                            <input
                              placeholder="N.º da Folha"
                              type="text"
                              class="form-control form-control-sm"
                              name="page_number"
                            />
                          </div>
                          <div class="col-md-6 mb-3">
                            <input
                              placeholder="Data de Emissão"
                              type="text"
                              class="form-control form-control-sm"
                              name="issue_date"
                            />
                          </div>
                          <div class="col-md-6 mb-3">
                            <input
                              placeholder="N.º do Selo do Certificado"
                              type="text"
                              class="form-control form-control-sm"
                              name="certificate_seal_number"
                            />
                          </div>
                          <div class="col-md-6 mb-3">
                            <input
                              placeholder="N.º do Selo do Histórico"
                              type="text"
                              class="form-control form-control-sm"
                              name="history_seal_number"
                            />
                          </div>
                        </div>
                        <button
                          type="submit"
                          class="btn btn-success btn-sm text-uppercase"
                        >
                          SALVAR
                        </button>
                      </form>
                    </div>

                    <div class="col-md-8">
                      <!-- //? Livros -->
                      <small class="p-0"
                        >Livros emitidos para o aluno até o momento:</small
                      >
                      <ul class="list-group" v-if="!!hasBooks.length">
                        <li
                          v-for="(book, key) in student.books"
                          :key="key"
                          class="list-group-item d-flex justify-content-between align-items-center"
                        >
                          <button
                            class="btn btn-sm btn-outline-dark"
                            :title="`${key} - ${book.created_at}`"
                          >
                            <span v-if="book.book_type"><strong>Tipo:</strong> {{ book.book_type.name }} | </span>
                            N.º de Registro: {{ book.registration_number }} / N.º do
                            Livro: {{ book.book_number }} / N.º da Folha:
                            {{ book.page_number }} / Data de Emissão:
                            {{ book.issue_date }} / N.º do Selo do Certificado:
                            {{ book.certificate_seal_number }} / N.º do Selo do
                            Histórico: {{ book.history_seal_number }} /
                          </button>

                          <ButtonDelete @delete="handlerDelete(book.id, 'books')" />
                        </li>
                      </ul>
                    </div>
                  </div>

                </div>
              </v-tab-item>

              <v-tab-item>
                <div class="p-2">
                  
                  <div class="row my-2">
                    <div class="col-md-4">
                      <h6>Adicionar Observação</h6>
                      <form ref="formObservation" @submit.prevent="handlerCreateObservation">
                        <div class="mb-3">
                          <label for="observation" class="form-label">Observação</label>
                          <textarea
                            name="observation"
                            class="form-control form-control-sm"
                            rows="4"
                            placeholder="Digite a observação..."
                            required
                          ></textarea>
                        </div>
                        <button
                          type="submit"
                          class="btn btn-success btn-sm text-uppercase"
                        >
                          SALVAR OBSERVAÇÃO
                        </button>
                      </form>
                    </div>

                    <div class="col-md-8">
                      <small class="p-0">Observações registradas:</small>
                      <div v-if="!!hasObservations.length" class="mt-2">
                        <div
                          v-for="(observation, key) in hasObservations"
                          :key="key"
                          class="card mb-2"
                        >
                          <div class="card-body">
                            <p class="card-text">{{ observation.observation }}</p>
                            <div class="d-flex justify-content-between align-items-center">
                              <small class="text-muted">
                                <strong>Por:</strong> {{ observation.user.name }} | 
                                <strong>Criado:</strong> {{ observation.created_at_formatted }}
                              </small>
                              <div>
                                <button 
                                  class="btn btn-outline-primary btn-sm me-1" 
                                  @click="showModalEditObservation(observation)"
                                  title="Editar observação"
                                >
                                  <font-awesome-icon icon="edit" />
                                </button>
                                <ButtonDelete @delete="handlerDeleteObservation(observation.id)" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else class="alert alert-info mt-2" role="alert">
                        Nenhuma observação registrada para este aluno.
                      </div>
                    </div>
                  </div>

                </div>
              </v-tab-item>

              <v-tab-item>
                <div class="p-2">
                  
                  <div class="row my-2">
                    <div class="col-md-5">
                      <h6>{{ shipmentTracking.id ? 'Editar' : 'Adicionar' }} Acompanhamento de Envio</h6>
                      <form ref="formShipmentTracking" @submit.prevent="handlerSaveShipmentTracking">
                        
                        <div class="mb-3">
                          <label for="enrollment_date" class="form-label">Data da Matrícula</label>
                          <input
                            type="date"
                            name="enrollment_date"
                            class="form-control form-control-sm"
                            v-model="shipmentTracking.enrollment_date"
                          />
                        </div>

                        <div class="mb-3">
                          <label for="exam_completion_date" class="form-label">Conclusão da Prova</label>
                          <input
                            type="date"
                            name="exam_completion_date"
                            class="form-control form-control-sm"
                            v-model="shipmentTracking.exam_completion_date"
                          />
                        </div>

                        <div class="mb-3">
                          <label for="document_request_date" class="form-label">Solicitação de Documento</label>
                          <input
                            type="date"
                            name="document_request_date"
                            class="form-control form-control-sm"
                            v-model="shipmentTracking.document_request_date"
                          />
                        </div>

                        <div class="mb-3">
                          <label for="pdf_sent_date" class="form-label">Data de Envio do Documento em PDF</label>
                          <input
                            type="date"
                            name="pdf_sent_date"
                            class="form-control form-control-sm"
                            v-model="shipmentTracking.pdf_sent_date"
                          />
                        </div>

                        <div class="mb-3">
                          <label for="physical_sent_date" class="form-label">Data de Envio do Documento Físico</label>
                          <input
                            type="date"
                            name="physical_sent_date"
                            class="form-control form-control-sm"
                            v-model="shipmentTracking.physical_sent_date"
                          />
                        </div>

                        <div class="mb-3">
                          <label for="tracking_code" class="form-label">Código de Rastreio</label>
                          <input
                            type="text"
                            name="tracking_code"
                            class="form-control form-control-sm"
                            v-model="shipmentTracking.tracking_code"
                            placeholder="Digite o código de rastreio"
                          />
                        </div>

                        <div class="mb-3">
                          <label for="expected_delivery_date" class="form-label">Previsão de Entrega</label>
                          <input
                            type="date"
                            name="expected_delivery_date"
                            class="form-control form-control-sm"
                            v-model="shipmentTracking.expected_delivery_date"
                          />
                        </div>

                        <div class="mb-3">
                          <label for="received_date" class="form-label">Data de Recebimento</label>
                          <input
                            type="date"
                            name="received_date"
                            class="form-control form-control-sm"
                            v-model="shipmentTracking.received_date"
                          />
                        </div>

                        <div class="mb-3">
                          <label for="observations" class="form-label">Observações</label>
                          <textarea
                            name="observations"
                            class="form-control form-control-sm"
                            rows="3"
                            v-model="shipmentTracking.observations"
                            placeholder="Digite observações sobre o envio..."
                          ></textarea>
                        </div>

                        <div class="d-flex gap-2">
                          <button
                            type="submit"
                            class="btn btn-success btn-sm text-uppercase"
                          >
                            SALVAR
                          </button>
                          <button
                            type="button"
                            class="btn btn-secondary btn-sm text-uppercase"
                            @click="resetShipmentTracking"
                          >
                            LIMPAR
                          </button>
                          <button
                            v-if="shipmentTracking.id"
                            type="button"
                            class="btn btn-danger btn-sm text-uppercase"
                            @click="handlerDeleteShipmentTracking"
                          >
                            EXCLUIR
                          </button>
                        </div>
                      </form>
                    </div>

                    <div class="col-md-7">
                      <small class="p-0">Informações de acompanhamento:</small>
                      <div v-if="shipmentTracking.id" class="mt-2">
                        <table class="table table-sm table-bordered">
                          <tbody>
                            <tr>
                              <th scope="row">Data da Matrícula</th>
                              <td>{{ shipmentTracking.enrollment_date ? formatDate(shipmentTracking.enrollment_date) : '-' }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Conclusão da Prova</th>
                              <td>{{ shipmentTracking.exam_completion_date ? formatDate(shipmentTracking.exam_completion_date) : '-' }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Solicitação de Documento</th>
                              <td>{{ shipmentTracking.document_request_date ? formatDate(shipmentTracking.document_request_date) : '-' }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Data de Envio do PDF</th>
                              <td>{{ shipmentTracking.pdf_sent_date ? formatDate(shipmentTracking.pdf_sent_date) : '-' }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Data de Envio Físico</th>
                              <td>{{ shipmentTracking.physical_sent_date ? formatDate(shipmentTracking.physical_sent_date) : '-' }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Código de Rastreio</th>
                              <td>{{ shipmentTracking.tracking_code || '-' }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Previsão de Entrega</th>
                              <td>{{ shipmentTracking.expected_delivery_date ? formatDate(shipmentTracking.expected_delivery_date) : '-' }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Data de Recebimento</th>
                              <td>{{ shipmentTracking.received_date ? formatDate(shipmentTracking.received_date) : '-' }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Observações</th>
                              <td>{{ shipmentTracking.observations || '-' }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-else class="alert alert-info mt-2" role="alert">
                        Nenhum acompanhamento de envio registrado para este aluno.
                      </div>
                    </div>
                  </div>

                </div>
              </v-tab-item>

            </v-tabs>
          </v-card>
        </div>
       </div>

      <hr />
      <button
        class="btn btn-sm btn-secondary text-uppercase"
        @click="$router.go(-1)"
      >
        VOLTAR
      </button>
    </div>

    <LoadingPage v-else />

    <!-- Modal de Renegociação -->
    <RenegotiateFinancialModal
      v-model="showRenegotiateModal"
      :selected-installments="selectedFinancials"
      @success="handleRenegotiateSuccess"
    />

    <!-- MODAL STATUS HISTORY -->
    <div class="modal fade" id="modalStatusHistory" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Histórico de Status</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div v-if="statusHistory.length > 0">
              <table class="table table-bordered table-hover table-sm">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Status Anterior</th>
                    <th scope="col">Novo Status</th>
                    <th scope="col">Usuário</th>
                    <th scope="col">Data/Hora</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="history in statusHistory" :key="history.id">
                    <td>{{ history.id }}</td>
                    <td>
                      <span class="badge bg-secondary">{{ history.previous_status || 'N/A' }}</span>
                    </td>
                    <td>
                      <span class="badge bg-primary">{{ history.new_status }}</span>
                    </td>
                    <td>{{ history.user.name }}</td>
                    <td>{{ history.created_at }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="alert alert-info" role="alert">
              Nenhum histórico de status encontrado para este aluno.
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              data-bs-dismiss="modal"
            >
              FECHAR
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL FINANCIAL -->
    <!--//! @TODO criar um componente para os campos do financeiro - nao precisa engloba os VERBOS (POST, PUT) -->
    <div class="modal fade" id="modalFinancial" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Editar Financeiro</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <form ref="formFinancialUpdate" @submit.prevent="handlerFinancialUpdate"
            >
              <div class="row mb-3 form-update">

                <label for="id" class="col-sm-4 col-form-label">#</label>
                <div class="col-sm-8">
                  <input
                    disabled
                    type="text"
                    class="form-control form-control-sm"
                    name="id"
                  />
                </div>

                <!-- -- --  -->
                <label for="registration_id" class="col-sm-4 col-form-label">Matrícula</label>
                <div class="col-sm-8">
                  <input
                    disabled
                    type="text"
                    class="form-control form-control-sm"
                    name="registration_id"
                  />
                </div>
                <!-- -- --  -->
                <label for="value" class="col-sm-4 col-form-label">Valor</label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="value"
                    data-thousands="."
                    placeholder="0,00"
                    data-decimal=","
                    @change="recalculateChargeTotal"
                  />
                </div>
                <!-- -- --  -->
                <label for="punctuality_discount_display" class="col-sm-4 col-form-label">Desc. pontualidade</label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="punctuality_discount_display"
                    placeholder="0,00"
                    readonly
                  />
                  <small class="text-muted">Aplicado automaticamente em mensalidades pagas até o vencimento.</small>
                </div>
                <!-- -- --  -->
                <label for="fine_amount" class="col-sm-4 col-form-label">Multa</label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="fine_amount"
                    data-thousands="."
                    placeholder="0,00"
                    data-decimal=","
                    @change="recalculateChargeTotal"
                  />
                  <small class="text-muted">Calculada automaticamente. Pode zerar ou alterar na baixa / negociação.</small>
                </div>
                <!-- -- --  -->
                <label for="interest_amount" class="col-sm-4 col-form-label">Juros</label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="interest_amount"
                    data-thousands="."
                    placeholder="0,00"
                    data-decimal=","
                    @change="recalculateChargeTotal"
                  />
                </div>
                <!-- -- --  -->
                <label for="amount_charged" class="col-sm-4 col-form-label">Total a cobrar</label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="amount_charged"
                    data-thousands="."
                    placeholder="0,00"
                    data-decimal=","
                    readonly
                  />
                  <button type="button" class="btn btn-outline-secondary btn-sm mt-1 me-1" @click="waiveCharges">
                    Zerar multa e juros
                  </button>
                  <button type="button" class="btn btn-outline-secondary btn-sm mt-1" @click="restoreSuggestedCharges">
                    Recalcular
                  </button>
                </div>
                <!-- -- --  -->
                <label for="quota" class="col-sm-4 col-form-label">Parcela</label>
                <div class="col-sm-8">
                  <input
                    type="number"
                    @keyup="filterNonNumeric"
                    class="form-control form-control-sm"
                    name="quota"
                  />
                </div>
                <!-- -- -- -->
                <label for="due_date" class="col-sm-4 col-form-label">Vencimento</label>
                <div class="col-sm-8">
                  <input
                    type="date"
                    class="form-control form-control-sm"
                    name="due_date"
                  />

                  <input class="form-check-input" type="checkbox" v-model="isChecked" id="applyDueDateToBill">
                    <small> Aplicar este vencimento se o pagamento for boleto.</small>

                </div>

                <!-- -- -- -->
                <label for="paid" class="col-sm-4 col-form-label">Quitado</label>
                <div class="col-sm-8">
                  <select
                    name="paid"
                    class="form-control form-control-sm"
                    v-model="paidValue"
                    @change="onPaidStatusChange"
                  >
                    <option value="" selected disabled>--</option>
                    <option value="0">NÃO</option>
                    <option value="1">SIM</option>
                  </select>
                </div>

                <!-- -- --  -->
                <label for="service_type_id" class="col-sm-4 col-form-label">Tipo de Serviço</label>
                <div class="col-sm-8">
                  <select
                    name="service_type_id"
                    class="form-control form-control-sm"
                  >
                    <option value="" selected disabled>-- Selecione --</option>
                    <option
                      v-for="(service, key) in serviceTypes"
                      :key="key"
                      :value="service.id"
                    >
                      {{ service.name | uppercase }}
                    </option>
                  </select>
                </div>

                <!-- -- --  -->
                <label for="payment_type" class="col-sm-4 col-form-label">Forma de Pagamento</label>
                <div class="col-sm-8">
                  <select
                    name="payment_type"
                    class="form-control form-control-sm"
                  >
                    <option value="" selected disabled>-- Selecione --</option>
                    <option
                      v-for="(payment, key) in paymentTypes"
                      :key="key"
                      :value="payment.id"
                    >
                      {{ payment.name | uppercase }}
                    </option>
                  </select>
                </div>

                <!-- -- --  -->
                <label for="pay_day" class="col-sm-4 col-form-label">Dia do Pagamento</label>
                <div class="col-sm-8">
                  <input
                    type="date"
                    class="form-control form-control-sm"
                    name="pay_day"
                  />
                </div>

                <!-- -- --  -->
                <label for="observations" class="col-sm-12 col-form-label">Observação geral</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="observations"
                  />
                </div>

                <label for="financial_observation" class="col-sm-12 col-form-label">Observação financeiro</label>
                <div class="col-sm-12">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    name="financial_observation"
                  />
                </div>
                
                <div class="col-sm-12" v-if="!!storeFinancial.gateway_response">
                  <hr>
                  <label for="gateway_response" class="col-form-label text-primary">Feedback do Gateway de Pagamento</label>
                  <button
                    type="button"
                    class="btn btn-link btn-sm"
                    @click="toggleGatewayResponse"
                  >
                    {{ showGatewayResponse ? "Ocultar" : "Exibir" }} JSON
                  </button>
                  <div v-if="showGatewayResponse" class="json-container">
                    <pre>{{ formattedGatewayResponse }}</pre>
                  </div>
                </div>
                
                <p class="text-secondary" v-html="msgAlertTickerStreet"></p>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <button type="submit" :class="{ 'btn btn-primary btn-sm': true, 'd-none': storeFinancial.paid_by_user_id == userMercadoPago }">
                    ATUALIZAR
                  </button>
                </div>
                <div class="col-md-8 text-end">
                  <a v-if="showReceipt" type="button" @click.prevent="generateReceipt()" class="link-secondary">
                    <u>🧾 Emitir Recibo</u>
                  </a>
                  <a 
                    v-if="!showReceipt && (paymentTypeShowButton == 2 || paymentTypeShowButton == 1)" 
                    type="button" 
                    target="_blank" 
                    class="link-primary" 
                    @click="mpStandard"
                  >
                     <u>💳 Pagar com Cartão de Crédito/Boleto.</u>
                  </a>
                  <br/>
                  <a 
                    v-if="!showReceipt && paymentTypeShowButton == 4" 
                    type="button" 
                    target="_blank" 
                    class="link-default" 
                    @click="mpTicket"
                  >
                     <u>🧾 Gerar Boleto Mercado Pago.</u>
                  </a>
                  
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              data-bs-dismiss="modal"
            >
              FECHAR
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL EDIT OBSERVATION -->
    <div class="modal fade" id="modalEditObservation" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Editar Observação</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <form ref="formObservationUpdate" @submit.prevent="handlerUpdateObservation">
              <div class="mb-3">
                <label for="observation_edit" class="form-label">Observação</label>
                <textarea
                  name="observation"
                  class="form-control form-control-sm"
                  rows="4"
                  placeholder="Digite a observação..."
                  required
                ></textarea>
              </div>
              <button type="submit" class="btn btn-primary btn-sm">
                ATUALIZAR
              </button>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              data-bs-dismiss="modal"
            >
              FECHAR
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL FINANCIAL RESPONSIBLE -->
    <div class="modal fade" id="modalFinancialResponsible" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ editingResponsibleId ? 'Editar' : 'Cadastrar' }} Responsável Financeiro</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <form ref="formFinancialResponsible" @submit.prevent="handlerSaveFinancialResponsible">
              <div class="row">
                <div class="form-group col-md-6">
                  <label for="name" class="required">Nome </label>
                  <input
                    type="text"
                    name="name"
                    class="form-control form-control-sm"
                    required
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="cpf" class="required">CPF </label>
                  <TheMask
                    type="text"
                    name="cpf"
                    class="form-control form-control-sm"
                    :mask="['###.###.###-##']"
                    required
                  />
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-6">
                  <label for="phone">Telefone</label>
                  <TheMask
                    type="text"
                    name="phone"
                    class="form-control form-control-sm"
                    :mask="['(##)#####-#####']"
                    :masked="true"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="email">E-mail</label>
                  <input
                    type="email"
                    name="email"
                    class="form-control form-control-sm"
                  />
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-2">
                  <label for="zip_code">CEP</label>
                  <input
                    type="text"
                    name="zip_code"
                    class="form-control form-control-sm"
                    maxlength="8"
                    @blur="zipCodeQueryResponsible"
                  />
                </div>
                <div class="form-group col-md-6">
                  <label for="address">Endereço</label>
                  <input
                    type="text"
                    name="address"
                    class="form-control form-control-sm"
                  />
                </div>
                <div class="form-group col-md-2">
                  <label for="number">Número</label>
                  <input
                    type="text"
                    name="number"
                    class="form-control form-control-sm"
                  />
                </div>
                <div class="form-group col-md-2">
                  <label for="complement">Complemento</label>
                  <input
                    type="text"
                    name="complement"
                    class="form-control form-control-sm"
                  />
                </div>
              </div>

              <div class="row">
                <div class="form-group col-md-4">
                  <label for="neighborhood">Bairro</label>
                  <input
                    type="text"
                    name="neighborhood"
                    class="form-control form-control-sm"
                  />
                </div>
                <div class="form-group col-md-4">
                  <label for="city">Cidade</label>
                  <input
                    type="text"
                    name="city"
                    class="form-control form-control-sm"
                  />
                </div>
                <div class="form-group col-md-4">
                  <label for="state">Estado</label>
                  <input
                    type="text"
                    name="state"
                    class="form-control form-control-sm"
                    maxlength="2"
                  />
                </div>
              </div>

              <div class="text-center mt-3">
                <button type="submit" class="btn btn-success btn-sm">
                  {{ editingResponsibleId ? 'ATUALIZAR' : 'SALVAR' }}
                </button>
                <button
                  type="button"
                  class="btn btn-secondary btn-sm ms-2"
                  data-bs-dismiss="modal"
                >
                  CANCELAR
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL HISTÓRICO DE EMISSÕES DO RECIBO -->
    <div class="modal fade" id="modalReceiptEmissions" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Histórico de Emissões do Recibo</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="receiptEmissionsLoading" class="text-center py-3">
              <div class="spinner-border spinner-border-sm" role="status"></div>
              <span class="ms-2">Carregando...</span>
            </div>
            <div v-else-if="receiptEmissionsList.length === 0" class="alert alert-info">
              Nenhuma emissão registrada para este recibo.
            </div>
            <table v-else class="table table-sm table-striped">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Usuário</th>
                  <th>Data/Hora da Emissão</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(emission, idx) in receiptEmissionsList" :key="emission.id">
                  <td>{{ idx + 1 }}</td>
                  <td>{{ emission.user ? emission.user.name : '—' }}</td>
                  <td>{{ emission.emitted_at }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">FECHAR</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from "@/services";
import axios from "axios";
import {
  errorsToString,
  convertDateToDB,
  handlerDelete,
  decimal,
  filterNonNumeric,
  studentStatusOptions,
  documentStorageUrl,
} from "@/helpers";
import LoadingPage from "@/components/LoadingPage.vue";
import ButtonDelete from "@/components/ButtonDelete.vue";
import RenegotiateFinancialModal from "@/components/modals/RenegotiateFinancialModal.vue";
import SearchableSelect from "@/components/SearchableSelect.vue";

export default {
  name: "StudentEdit",
  components: {
    LoadingPage,
    ButtonDelete,
    RenegotiateFinancialModal,
    SearchableSelect,
  },
  props: ["id"],
  data() {
    return {
      activeTab: 0,
      convertDateToDB,
      decimal,
      handlerDelete,
      filterNonNumeric,
      isChecked:false,
      student: [],
      teams: [],
      bookTypes: [],
      serviceTypes: [],
      paymentTypes: [],
      financialResponsibles: [],
      statusOptions: studentStatusOptions,
      team_id: "",
      financial_id: "",
      teamRegistration: "",
      paymentTypeShowButton: "",
      financial: {
        id: "",
        registration_id: "",
        payment_type: "",
        service_type_id: "",
        due_date: "",
        quota: "",
        paid: "",
        value: "",
        financial_observation: "",
      },
      showReceipt: 0,
      paidValue: "",
      hasRegistration: [],
      hasDocuments: [],
      hasBooks: [],
      hasObservations: [],
      observation_id: "",
      numberOfTimesToEnter: 1,
      students: [],
      msgAlertTickerStreet: "",
      storeFinancial: {},
      userMercadoPago: 100,
      showGatewayResponse: false,
      statusHistory: [],
      selectedFinancials: [],
      showRenegotiateModal: false,
      filterPaid: '',
      serviceTypeFilter: '',
      filterParcelId: '',
      filterFinancialObservation: '',
      filterTeam: '',
      agreementDrafts: [],
      editingResponsibleId: null,
      receiptEmissionsList: [],
      receiptEmissionsLoading: false,
      documentPreviews: {},
      financialHeaders: [
          { text: 'ID', value: 'id', sortable: true },
          { text: 'Turma', value: 'team_name', sortable: true },
          { text: 'Serviço', value: 'service_type.name', sortable: false },
          { text: 'N.º', value: 'quota', sortable: true },
          { text: 'Valor', value: 'value', sortable: true },
          { text: 'Desc. pontualidade', value: 'punctuality_discount', sortable: true },
          { text: 'Multa', value: 'fine', sortable: true },
          { text: 'Juros', value: 'interest', sortable: true },
          { text: 'Total', value: 'total', sortable: true },
          { text: 'Vencimento', value: 'due_date', sortable: true },
          { text: 'Quitado', value: 'paid', sortable: true },
          { text: 'Forma Pgto', value: 'payment_type.name', sortable: false },
          { text: 'Data Pagamento', value: 'pay_day', sortable: true },
          { text: 'Observação', value: 'observations', sortable: false },
          { text: 'Observação Financeira', value: 'financial_observation', sortable: false },
          { text: 'Usuário Atualizador', value: 'updated_user.name', sortable: false },
          { text: 'Usuário da Baixa', value: 'paid_by_user.name', sortable: false },
          { text: 'Ações', value: 'actions', sortable: false, width: '148px' },
      ],
      shipmentTracking: {
        id: null,
        student_id: null,
        enrollment_date: null,
        exam_completion_date: null,
        document_request_date: null,
        pdf_sent_date: null,
        physical_sent_date: null,
        tracking_code: null,
        expected_delivery_date: null,
        received_date: null,
        observations: null,
      },
    };
  },
  watch: {
    numberOfTimesToEnter(n, o) {
      isNaN(Number(n)) &&
        setTimeout(() => (this.numberOfTimesToEnter = o), 500);
    },
    paidValue(n, o) {
      this.showReceipt = +n;
    },
    '$route.query.tab'() {
      this.applyTabFromQuery();
    },
  },
  computed: {
    formattedGatewayResponse() {
      return JSON.stringify(JSON.parse(this.storeFinancial.gateway_response), null, 2);
    },
      filteredFinancials() {
        // Junta todos os financeiros das matrículas
        let all = this.hasRegistration.flatMap(r => r.financials.map(f => ({ ...f, team_name: r.team.name, team_id: r.team.id })));
        let filtered = all;
        if (this.filterPaid !== '') {
          filtered = filtered.filter(f => {
            if (this.filterPaid === 'paid') {
              return !!f.paid;
            } else if (this.filterPaid === 'overdue') {
              if (f.paid) return false;
              // Converte data do formato DD/MM/YYYY para Date
              const dueDateStr = f.due_date.includes('/') 
                ? f.due_date.split('/').reverse().join('-') 
                : f.due_date;
              const dueDate = new Date(dueDateStr + 'T00:00:00');
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              return dueDate < today;
            } else if (this.filterPaid === 'upcoming') {
              if (f.paid) return false;
              // Converte data do formato DD/MM/YYYY para Date
              const dueDateStr = f.due_date.includes('/') 
                ? f.due_date.split('/').reverse().join('-') 
                : f.due_date;
              const dueDate = new Date(dueDateStr + 'T00:00:00');
              const today = new Date();
              today.setHours(0, 0, 0, 0);
              return dueDate >= today;
            }
            return true;
          });
        }
        if (this.filterTeam !== '') {
          filtered = filtered.filter(f => String(f.team_id) === this.filterTeam);
        }
        if (this.serviceTypeFilter !== '') {
          filtered = filtered.filter(f => String(f.service_type_id) === this.serviceTypeFilter);
        }
        if (this.filterParcelId !== '') {
          filtered = filtered.filter(f => String(f.id).includes(this.filterParcelId));
        }
        if (this.filterFinancialObservation !== '') {
          filtered = filtered.filter(f => (f.financial_observation || '').toLowerCase().includes(this.filterFinancialObservation.toLowerCase()));
        }
        return filtered;
      },
  },
  methods: {
    toggleGatewayResponse() {
      this.showGatewayResponse = !this.showGatewayResponse;
    },
    getPaymentStatusColor(item) {
      if (item.paid) {
        return 'success'; // Verde - Pago
      }
      
      // Converte data do formato DD/MM/YYYY para Date
      const dueDateStr = item.due_date.includes('/') 
        ? item.due_date.split('/').reverse().join('-') 
        : item.due_date;
      const dueDate = new Date(dueDateStr + 'T00:00:00');
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (dueDate < today) {
        return 'error'; // Vermelho - Vencido
      }
      
      return 'warning'; // Amarelo - A vencer
    },
    getPaymentStatusText(item) {
      if (item.paid) {
        return 'PAGO';
      }
      
      // Converte data do formato DD/MM/YYYY para Date
      const dueDateStr = item.due_date.includes('/') 
        ? item.due_date.split('/').reverse().join('-') 
        : item.due_date;
      const dueDate = new Date(dueDateStr + 'T00:00:00');
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (dueDate < today) {
        return 'VENCIDO';
      }
      
      return 'A VENCER';
    },
    async updateStatus() {
      try {
        const { data } = await api.put(`/students/${this.$route.params.id}/status`, {
          status: this.student.status
        });

        Toast.fire("Sucesso", data.message, "success");
      } catch (error) {
        Toast.fire("Erro", error.response?.data?.message || "Erro ao atualizar status", "error");
        // Recarrega os dados do aluno em caso de erro
        this.getItens();
      }
    },
    async showStatusHistory() {
      try {
        const { data } = await api.get(`/students/${this.$route.params.id}/status-history`);
        
        this.statusHistory = data.data;
        
        jQuery('#modalStatusHistory').modal('show');
      } catch (error) {
        Toast.fire("Erro", error.response?.data?.message || "Erro ao carregar histórico", "error");
      }
    },
    openWhatsApp() {
      if (!this.student.phone) {
        Toast.fire("Aviso", "Nenhum telefone cadastrado", "warning");
        return;
      }

      // Remove todos os caracteres não numéricos do telefone
      const phoneNumber = this.student.phone.replace(/\D/g, '');
      
      if (phoneNumber.length < 10) {
        Toast.fire("Aviso", "Número de telefone inválido", "warning");
        return;
      }

      // Adiciona o código do país (55 para Brasil) se não tiver
      const fullNumber = phoneNumber.startsWith('55') ? phoneNumber : `55${phoneNumber}`;
      
      // Monta a URL do WhatsApp com uma mensagem padrão
      const message = encodeURIComponent('Saudações! Aqui é da equipe da Paideia Educacional');
      const whatsappUrl = `https://web.whatsapp.com/send?phone=${fullNumber}&text=${message}`;
      
      // Abre em uma nova aba
      window.open(whatsappUrl, '_blank');
    },
    async zipCodeQuery() { //@TODO mover para uma unica funcao.

        const cepLimpo = this.student.cep.replace(/\D/g, '')
        
        if (cepLimpo.length !== 8) 
          return

        try {

          const response = await axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`)
          
          if (!response.data.erro) {
            this.student.street = response.data.logradouro
            this.student.neighborhood = response.data.bairro
            this.student.uf = response.data.uf
            this.student.city = response.data.localidade
          } else {
            this.student.street = ''
            this.student.neighborhood = ''
            this.student.uf = ''
            this.student.city = ''
            Toast.fire("Erro", 'CEP não encontrado', "error")
          }
        } catch (error) {
          console.error('Erro ao consultar CEP:', error)
          Toast.fire("Erro", 'Erro ao buscar informações do CEP', "error")
        }
    },
    async getImage() {
      try {
        const response = await api.get(`/students/${this.$route.params.id}/get-image`,
          {
            responseType: "blob",
          }
        );
        if (response.status === 200) {
          const imageUrl = URL.createObjectURL(response.data);
          document.querySelector("#student-photo").classList.remove('d-none');
          document.querySelector("#student-photo").src = imageUrl;
          document.querySelector("#student-photo").classList.add("photo");
        } else {
          Toast.fire("Erro", response.statusText, "error");
        }
      } catch (error) {
        document.querySelector("#student-photo").classList.add('d-none');
        console.log(`> Photo ${error.response.statusText}`);
      }
    },
    async changeStudentOfDocument(e) {
      try {
        const { data } = await api.put(`/documents/${e.target.dataset.documentId}`,{ student_id: e.target.value });
        Toast.fire("Sucesso", data.message, "success");
      } catch (error) {
        Toast.fire("Erro", error.response.data.message, "error");
      }
    },
    highPayStatus(financial) {
      const dueDate = new Date(this.convertDateToDB(financial.due_date));
      const dataAtual = new Date();

      let _class = "";

      if (financial.paid) {
        _class = "table-success";
      } else if (dueDate < dataAtual) {
        _class = "table-danger";
      }

      return _class;
    },
    async getBlob(doc) {
      await api
        .get(documentStorageUrl(doc.folder, doc.file_name), {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });

          const link = document.createElement("a");

          link.href = URL.createObjectURL(blob);
          link.download = doc.file_name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((error) => console.error(error));
    },
    async destroyPDF(doc) {
      api
        .get(`/documents/${doc.folder}/${doc.file_name}/remove`)
        .then((response) => {
          Toast.fire("Sucesso", response.data.message, "success");
          this.getItens();
        })
        .catch((error) => {
          Toast.fire("Erro", error.response.data.message, "error");
        });
    },
    async getTeams() {
      await api.get(`/teams?page=0&perPage=99999&sortBy=name&forPagination=1`).then((res) => {
        this.teams = res.data.data;
      });
    },
    async getServiceType() {
      await api.get(`/service-types?page=0&perPage=99999&sortBy=name`).then((res) => {
        this.serviceTypes = res.data.data;
      });
    },
    async getPaymentService() {
      await api.get(`/payment-types?page=0&perPage=99999&sortBy=name`).then((res) => {
        this.paymentTypes = res.data.data;
      });
    },
    async getBookTypes() {
      await api.get(`/book-types?page=0&perPage=99999&sortBy=name`).then((res) => {
        this.bookTypes = res.data.data;
      });
    },
    async getFinancialResponsibles() {
      try {
        const { data } = await api.get(`/financial-responsibles?page=0&perPage=99999&sortBy=name`);
        this.financialResponsibles = data.data || data;
      } catch (error) {
        console.error('Erro ao buscar responsáveis financeiros:', error);
        this.financialResponsibles = [];
      }
    },
    async getItens() {
      await api.get(`/students/${this.id}`).then((res) => {
        const student = res.data[0];
        student.birth_date = this.convertDateToDB(student.birth_date);

        this.hasRegistration = student.registrations;
        this.hasDocuments = student.documents;
        this.hasBooks = student.books;

        this.student = student;
      });

      // Buscar observações
      await this.getObservations();
      this.loadDocumentPreviews();
    },
    async loadDocumentPreviews() {
      if (!this.student?.documents?.length) return;
      this.documentPreviews = {};
      for (const doc of this.student.documents) {
        try {
          const response = await api.get(documentStorageUrl(doc.folder, doc.file_name), { responseType: 'blob' });
          const blob = new Blob([response.data], { type: 'application/pdf' });
          this.$set(this.documentPreviews, doc.id, URL.createObjectURL(blob));
        } catch (e) {
          // arquivo não encontrado — mantém placeholder
        }
      }
    },
    async handlerCreateBook() {
      try {
        const formData = new FormData(this.$refs.formBook);
        formData.set("student_id", this.id);

        const { data } = await api.post(`/books`, formData);

        Toast.fire("Sucesso", data.message, "success");

        this.getItens();
      } catch (error) {
        Toast.fire("Erro", error.response.data.message, "error");
      }
    },
    async handlerFinancialUpdate() {
      let receiptPreviewWindow = null;
      try {
        const formData = new FormData(this.$refs.formFinancialUpdate);
        formData.set("value", this.decimal(formData.get("value")));

        const financialId = this.financial_id;
        const isPaying = String(formData.get("paid")) === "1";
        const wasAlreadyPaid = !!Number(this.storeFinancial?.paid);
        const shouldEmitReceipt = isPaying && !wasAlreadyPaid;
        receiptPreviewWindow = shouldEmitReceipt ? window.open("", "_blank") : null;
        if (isPaying) {
          const fine = this.decimal(formData.get("fine_amount") || "0");
          const interest = this.decimal(formData.get("interest_amount") || "0");
          const punctualityDiscount = this.decimal(formData.get("punctuality_discount_display") || "0");
          const value = parseFloat(formData.get("value")) || 0;
          formData.set("fine_amount", fine);
          formData.set("interest_amount", interest);
          formData.set("amount_charged", (value - punctualityDiscount + fine + interest).toFixed(2));
        } else {
          formData.delete("fine_amount");
          formData.delete("interest_amount");
          formData.delete("amount_charged");
        }

        const { data } = await api.put(
          `/financials/${financialId}`,
          Object.fromEntries(formData.entries())
        );

        Toast.fire("Sucesso", data.message, "success");

        if (shouldEmitReceipt) {
          await this.generateReceipt(financialId, true, receiptPreviewWindow);
        }

        this.getItens();

        jQuery('#modalFinancial').modal('hide');

        this.financial_id = null;
      } catch (error) {
        if (receiptPreviewWindow) {
          receiptPreviewWindow.close();
        }
        Toast.fire("Erro", error.response.data.message, "error");
      }
    },
    formatCharge(value) {
      return Number(value || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    fillChargeFields(fine, interest, total, punctualityDiscount = 0) {
      const form = this.$refs.formFinancialUpdate;
      if (!form) return;

      const punctualityInput = form.querySelector('[name="punctuality_discount_display"]');
      const fineInput = form.querySelector('[name="fine_amount"]');
      const interestInput = form.querySelector('[name="interest_amount"]');
      const totalInput = form.querySelector('[name="amount_charged"]');

      if (punctualityInput) punctualityInput.value = this.formatCharge(punctualityDiscount);
      if (fineInput) fineInput.value = this.formatCharge(fine);
      if (interestInput) interestInput.value = this.formatCharge(interest);
      if (totalInput) totalInput.value = this.formatCharge(total);
    },
    recalculateChargeTotal() {
      const form = this.$refs.formFinancialUpdate;
      if (!form) return;

      const value = this.decimal(form.querySelector('[name="value"]').value || "0");
      const punctualityDiscount = this.decimal(form.querySelector('[name="punctuality_discount_display"]')?.value || "0");
      const fine = this.decimal(form.querySelector('[name="fine_amount"]').value || "0");
      const interest = this.decimal(form.querySelector('[name="interest_amount"]').value || "0");
      const totalInput = form.querySelector('[name="amount_charged"]');

      if (totalInput) {
        totalInput.value = this.formatCharge(value - punctualityDiscount + fine + interest);
      }
    },
    waiveCharges() {
      const form = this.$refs.formFinancialUpdate;
      if (!form) return;

      const originalValue = this.decimal(form.querySelector('[name="value"]').value || "0");
      const punctualityDiscount = this.decimal(form.querySelector('[name="punctuality_discount_display"]')?.value || "0");
      this.fillChargeFields(0, 0, originalValue - punctualityDiscount, punctualityDiscount);
    },
    restoreSuggestedCharges() {
      const data = this.storeFinancial || {};
      this.fillChargeFields(data.fine, data.interest, data.total, data.punctuality_discount);
    },
    todayInputDate() {
      const d = new Date();
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    onPaidStatusChange() {
      const form = this.$refs.formFinancialUpdate;
      const payDayInput = form && form.querySelector('[name="pay_day"]');
      if (!payDayInput) {
        return;
      }

      if (String(this.paidValue) === "1") {
        payDayInput.value = this.todayInputDate();
        return;
      }

      payDayInput.value = "";
    },
    increaseMonthsInstallments(_date, _increment) {
      const date = new Date(`${_date}T00:00:00`);

      date.setMonth(date.getMonth() + _increment);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");

      return `${year}-${month}-${String(date.getDate()).padStart(2, "0")}`;
    },
    async handlerFinancial() {
      try {
        const form = this.$refs.formFinancial;
        const mes = form.querySelector('[name="due_date"]').value;
        var quota = +form.querySelector('[name="quota"]').value;

        if (isNaN(this.numberOfTimesToEnter))
          return Toast.fire(
            "Atenção",
            "Por favor, preencha a quantidade de forma correta.",
            "warning"
          );

        for (let i = 0; i < this.numberOfTimesToEnter; i++) {
          const formData = new FormData(form);

          formData.set("value", this.decimal(formData.get("value")));
          formData.set("due_date", this.increaseMonthsInstallments(mes, i));
          formData.set("quota", quota++);

          var { data } = await api.post(`/financials`, formData);

          Toast.fire("Sucesso", data.message, "success");
        }

        this.getItens();
      } catch (error) {
        Toast.fire("Erro", error.response.data.message, "error");
      }
    },
    async generateStatement() {
      /** Gera extrato financeiro. */

      try {
        this.loading = !this.loading;

        await api
          .get(`/exports/student-financial-history/${this.$route.params.id}`, {
            responseType: "blob",
          })
          .then((response) => {
            const blob = new Blob([response.data], { type: "application/pdf" });

            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download =
              `Extrato Financeiro - ` + this.student.name.toUpperCase();
            a.click();
          });
      } catch (error) {
        Toast.fire("Erro", error.message, "error");
      }

      this.loading = !this.loading;
    },
    async mpTicket() {

      console.log('this.isChecked', this.isChecked); ;

      let postData = {};

      const formData = new FormData(this.$refs.formFinancialUpdate);
      const extractedData = Object.fromEntries(formData.entries());

      if(this.isChecked && !!extractedData.due_date && extractedData.payment_type == 4) 
        postData.date_of_expiration = extractedData.due_date;
      
      try {
        this.loading = !this.loading;

        await api
          .post(`/mercadopago/ticket/${this.financial_id}`, postData, {responseType: "json",})
          .then((response) => {
            const initPointUrl = response.data.transaction_details.external_resource_url;

            if (initPointUrl) {
              window.open(initPointUrl, '_blank');
            } else {
              Toast.fire("Erro", "URL não encontrada no response", "error");
            }
          });
      } catch (error) {
        Toast.fire("Erro", error.response.data.error , "error");
      } finally {
        this.loading = !this.loading;
      }
    },
    async mpStandard() {

      try {
        this.loading = !this.loading;

        await api
          .post(`/mercadopago/preference/${this.financial_id}`, {
            responseType: "json",
          })
          .then((response) => {
            const initPointUrl = response.data.init_point;

            if (initPointUrl) {
              window.open(initPointUrl, '_blank');
            } else {
              Toast.fire("Erro", "URL não encontrada no response", "error");
            }
          });
      } catch (error) {
        Toast.fire("Erro", error.message, "error");
      } finally {
        this.loading = !this.loading;
      }
    },
    async generateReceipt(financialId = null, openInBrowser = false, previewWindow = null) {
      if (financialId != null && typeof financialId === "object") {
        financialId = null;
      }
      const id = financialId ?? this.financial_id;
      if (!id)
        return Toast.fire(
          "Erro",
          "Por favor, selecione uma pendência financeira.",
          "error"
        );

      try {
        this.loading = !this.loading;

        const response = await api.get(`/exports/receipt/${id}`, {
          responseType: "blob",
        });
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        if (openInBrowser) {
          if (previewWindow) {
            previewWindow.location = url;
          } else if (!window.open(url, "_blank")) {
            const a = document.createElement("a");
            a.href = url;
            a.download = `Recibo - ` + this.student.name.toUpperCase();
            a.click();
          }
        } else {
          const a = document.createElement("a");
          a.href = url;
          a.download = `Recibo - ` + this.student.name.toUpperCase();
          a.click();
        }

        setTimeout(() => URL.revokeObjectURL(url), 60000);
      } catch (error) {
        if (previewWindow) {
          previewWindow.close();
        }
        Toast.fire("Erro", error.message, "error");
      }

      this.loading = !this.loading;
    },
    async showModalFinancial(id, payment_type) {

      try {
        const { data } = await api.get(`/financials/${id}`);

        this.storeFinancial = data;

        this.showReceipt = data.paid;
        this.paidValue = data.paid;

        this.msgAlertTickerStreet = '';
        this.isChecked = false;

        if(data.gateway_response && data.payment_type == 4 && data.paid == 0) {
          const gatewayResponse = JSON.parse(data.gateway_response);
          this.msgAlertTickerStreet = gatewayResponse.hasOwnProperty('payment_type_id') && gatewayResponse.payment_type_id == 'ticket'
          ? `<p>
              Já existe um boleto em aberto para pagamento. 
              <a href="${gatewayResponse.transaction_details.external_resource_url}" target="_blank">
                Clique aqui
              </a> 
              para acessá-lo, ou você pode gerar um novo, se necessário.
            </p>` 
          : '';

          if(!!gatewayResponse.external_reference) /** Se esta chave possuir valor, significa que o vencimento manual do boleto foi adicionado. */
            this.isChecked = true;

        }

        for (let field in data) {
          const hasField = document.querySelector(
            `.form-update [name="${field}"]`
          );

          if (hasField) {
            if (field == "due_date" || field == "pay_day") {
              hasField.value = this.convertDateToDB(data[field]);
            } else if (field == "value") {
              const valorFormatado = data[field].toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              });

              hasField.value = valorFormatado;
            } else if (["fine", "interest", "punctuality_discount", "total", "fine_amount", "interest_amount", "amount_charged", "punctuality_discount_display"].includes(field)) {
              continue;
            } else {
              hasField.value = data[field];
            }
          }
        }

        this.fillChargeFields(data.fine, data.interest, data.total, data.punctuality_discount);

        jQuery("#modalFinancial").modal("show");

        this.financial_id = id;
        this.paymentTypeShowButton = payment_type.id;

      } catch (error) {
        Toast.fire("Erro", error.response.data.message, "error");
      }
    },
    async handlerRegistration() {
      try {
        const { data } = await api.post(`/registrations`, {
          student_id: this.id,
          team_id: this.teamRegistration,
        });

        Toast.fire("Sucesso", data.message, "success");

        this.getItens();
      } catch (error) {
        Toast.fire("Erro", error.response.data.message, "error");
      }
    },
    async updateRegistrationSistec(registration) {
      try {
        await api.put(`/registrations/${registration.id}`, {
          sistec_number: registration.sistec_number || null,
        });
      } catch (error) {
        Toast.fire("Erro", "Falha ao salvar Nº SISTEC.", "error");
      }
    },
    async handlerSubmit() {

      const formData = new FormData(this.$refs.formStudent);

      formData.set('cpf', formData.get('cpf').replace(/[.\-]/g, ''));
      formData.set('cep', formData.get('cep').replace(/[.\-]/g, ''));
      formData.set('has_punctuality_discount', this.student.has_punctuality_discount ? '1' : '0');

      if (!this.student.has_punctuality_discount) {
        formData.set('punctuality_discount_amount', '');
      }

      formData.append('_method', 'put');

      try {
        const { data } = await api.post(`/students/${this.$route.params.id}`, formData,  {
           headers: {'Content-Type': 'multipart/form-data'}
         });

        Toast.fire("Sucesso", data.message, "success");
        this.getImage();

      } catch (error) {
        Toast.fire("Erro", errorsToString(error.response.data.errors), "error");
      }
    },
    async handlerRegisterStudentInTeam() {
      try {
        const { data } = await api.post(`/teams/register-student`, {
          student_id: this.id,
          team_id: this.team_id,
        });

        this.$router.push({ name: "students" });

        Toast.fire("Sucesso", data.message, "success");
      } catch (error) {
        Toast.fire("Erro", errorsToString(error.response.data.errors), "error");
      }
    }
    ,
    async generateContractAdditiveTerm(student_id, team_id) {
  
      if (!team_id || !student_id)
        return Toast.fire("Erro", "Por favor, selecione todos os campos.", "error");

      try {

        this.loading = !this.loading;

        const url = `/exports/student-contract-additive-term/${student_id}/${team_id}`;
        await api.get(url);

        await api
          .get(url,{ responseType: "blob"})
          .then((response) => {

            const blob = new Blob([response.data], { type: "application/pdf" });

            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = response.headers['content-type']; //@TODO passando nome do arquivo pelo `content-type` - POG     
            a.click();

            this.getItens();

          });
          
      } catch (error) {
        Toast.fire("Atenção", error.response.data.error, "warning");
      }
      this.loading = !this.loading;
    },
    async generateContract(student_id, team_id) {
  
      if (!team_id || !student_id)
        return Toast.fire("Erro", "Por favor, selecione todos os campos.", "error");

      try {

        this.loading = !this.loading;

        const url = `/exports/student-contract/${student_id}/${team_id}`;
        await api.get(url);

        await api
          .get(url,{ responseType: "blob"})
          .then((response) => {

            const blob = new Blob([response.data], { type: "application/pdf" });

            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = response.headers['content-type']; //@TODO passando nome do arquivo pelo `content-type` - POG     
            a.click();

            this.getItens();

          });
          
      } catch (error) {
        Toast.fire("Atenção", error.response.data.error, "warning");
      }
      this.loading = !this.loading;
    },
    async getObservations() {
      try {
        const { data } = await api.get(`/students/${this.id}/observations`);
        this.hasObservations = data;
      } catch (error) {
        console.error('Erro ao buscar observações:', error);
        this.hasObservations = [];
      }
    },
    async getAgreementDrafts() {
      try {
        const { data } = await api.get(`/financials/agreement-drafts/${this.$route.params.id}`);
        this.agreementDrafts = data.data || [];
      } catch (error) {
        // Silenciosamente define como array vazio se o endpoint não existir ou houver erro
        console.log('Minutas de acordo não disponíveis:', error.response?.status || error.message);
        this.agreementDrafts = [];
      }
    },
    async handlerCreateObservation() {
      try {
        const formData = new FormData(this.$refs.formObservation);

        const { data } = await api.post(`/students/${this.id}/observations`, {
          observation: formData.get('observation')
        });

        Toast.fire("Sucesso", "Observação adicionada com sucesso!", "success");

        // Limpar o formulário
        this.$refs.formObservation.reset();

        // Recarregar as observações
        await this.getObservations();
      } catch (error) {
        Toast.fire("Erro", error.response?.data?.message || "Erro ao adicionar observação", "error");
      }
    },
    async handlerDeleteObservation(observationId) {
      try {
        const { data } = await api.delete(`/students/${this.id}/observations/${observationId}`);

        Toast.fire("Sucesso", "Observação removida com sucesso!", "success");

        // Recarregar as observações
        await this.getObservations();
      } catch (error) {
        Toast.fire("Erro", error.response?.data?.message || "Erro ao remover observação", "error");
      }
    },
    showModalEditObservation(observation) {
      // Armazenar o ID da observação
      this.observation_id = observation.id;

      // Preencher o textarea com a observação atual
      const textarea = document.querySelector('#modalEditObservation textarea[name="observation"]');
      if (textarea) {
        textarea.value = observation.observation;
      }

      // Abrir o modal
      jQuery('#modalEditObservation').modal('show');
    },
    async showReceiptEmissions(financialId) {
      this.receiptEmissionsList = [];
      this.receiptEmissionsLoading = true;
      jQuery('#modalReceiptEmissions').modal('show');
      try {
        const { data } = await api.get(`/exports/receipt/${financialId}/emissions`);
        this.receiptEmissionsList = Array.isArray(data) ? data : [];
      } catch (error) {
        console.error('Erro ao buscar histórico de emissões:', error.response || error);
        const msg = error.response?.data?.message || 'Não foi possível carregar o histórico de emissões.';
        Toast.fire('Erro', msg, 'error');
      } finally {
        this.receiptEmissionsLoading = false;
      }
    },
    async handlerUpdateObservation() {
      try {
        const formData = new FormData(this.$refs.formObservationUpdate);

        const { data } = await api.put(`/students/${this.id}/observations/${this.observation_id}`, {
          observation: formData.get('observation')
        });

        Toast.fire("Sucesso", "Observação atualizada com sucesso!", "success");

        // Fechar o modal
        jQuery('#modalEditObservation').modal('hide');

        // Recarregar as observações
        await this.getObservations();

        // Limpar o ID
        this.observation_id = "";
      } catch (error) {
        Toast.fire("Erro", error.response?.data?.message || "Erro ao atualizar observação", "error");
      }
    },
    showModalFinancialResponsible() {
      this.editingResponsibleId = null;
      this.$refs.formFinancialResponsible?.reset();
      jQuery('#modalFinancialResponsible').modal('show');
    },
    async editFinancialResponsible() {
      if (!this.student.financial_responsible_id) {
        Toast.fire("Atenção", "Selecione um responsável financeiro para editar", "warning");
        return;
      }

      try {
        const { data } = await api.get(`/financial-responsibles/${this.student.financial_responsible_id}`);
        const responsible = data.data || data;

        this.editingResponsibleId = responsible.id;

        jQuery('#modalFinancialResponsible').modal('show');

        // Aguardar o modal abrir e o DOM atualizar
        await this.$nextTick();
        setTimeout(() => {
          const form = this.$refs.formFinancialResponsible;
          
          // Preencher campos normais
          form.querySelector('[name="name"]').value = responsible.name || '';
          form.querySelector('[name="email"]').value = responsible.email || '';
          form.querySelector('[name="zip_code"]').value = responsible.zip_code || '';
          form.querySelector('[name="address"]').value = responsible.address || '';
          form.querySelector('[name="number"]').value = responsible.number || '';
          form.querySelector('[name="complement"]').value = responsible.complement || '';
          form.querySelector('[name="neighborhood"]').value = responsible.neighborhood || '';
          form.querySelector('[name="city"]').value = responsible.city || '';
          form.querySelector('[name="state"]').value = responsible.state || '';
          
          // Preencher campos com TheMask (CPF e Telefone)
          const cpfInput = form.querySelector('[name="cpf"]');
          const phoneInput = form.querySelector('[name="phone"]');
          
          if (cpfInput) {
            cpfInput.value = responsible.cpf || '';
            cpfInput.dispatchEvent(new Event('input', { bubbles: true }));
          }
          
          if (phoneInput) {
            phoneInput.value = responsible.phone || '';
            phoneInput.dispatchEvent(new Event('input', { bubbles: true }));
          }
        }, 300);
      } catch (error) {
        Toast.fire("Erro", error.response?.data?.message || "Erro ao carregar dados do responsável", "error");
      }
    },
    async handlerSaveFinancialResponsible() {
      try {
        const formData = new FormData(this.$refs.formFinancialResponsible);
        
        // Limpar CPF
        const cpf = formData.get('cpf').replace(/[.\-]/g, '');
        formData.set('cpf', cpf);

        const payload = Object.fromEntries(formData.entries());
        let data;

        if (this.editingResponsibleId) {
          // Atualizar responsável existente
          const response = await api.put(`/financial-responsibles/${this.editingResponsibleId}`, payload);
          data = response.data;
          Toast.fire("Sucesso", "Responsável financeiro atualizado com sucesso!", "success");
        } else {
          // Criar novo responsável
          const response = await api.post(`/financial-responsibles`, payload);
          data = response.data;
          Toast.fire("Sucesso", "Responsável financeiro cadastrado com sucesso!", "success");
          
          // Selecionar o responsável recém-criado
          this.student.financial_responsible_id = data.data?.id || data.id;
        }

        // Recarregar lista de responsáveis
        await this.getFinancialResponsibles();

        // Fechar modal e limpar formulário
        jQuery('#modalFinancialResponsible').modal('hide');
        this.$refs.formFinancialResponsible.reset();
        this.editingResponsibleId = null;
      } catch (error) {
        Toast.fire("Erro", error.response?.data?.message || "Erro ao salvar responsável", "error");
      }
    },
    async zipCodeQueryResponsible() {
      const form = this.$refs.formFinancialResponsible;
      const cepInput = form.querySelector('[name="zip_code"]');
      const cepLimpo = cepInput.value.replace(/\D/g, '');
      
      if (cepLimpo.length !== 8) 
        return;

      try {
        const response = await axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);
        
        if (!response.data.erro) {
          form.querySelector('[name="address"]').value = response.data.logradouro;
          form.querySelector('[name="neighborhood"]').value = response.data.bairro;
          form.querySelector('[name="state"]').value = response.data.uf;
          form.querySelector('[name="city"]').value = response.data.localidade;
        } else {
          Toast.fire("Erro", 'CEP não encontrado', "error");
        }
      } catch (error) {
        console.error('Erro ao consultar CEP:', error);
        Toast.fire("Erro", 'Erro ao buscar informações do CEP', "error");
      }
    },
    openRenegotiateModal() {
      if (this.selectedFinancials.length === 0) {
        Toast.fire('Selecione ao menos uma parcela para negociar', '', 'warning');
        return;
      }

      // Validar se todas pertencem à mesma matrícula
      const registrationIds = [...new Set(this.selectedFinancials.map(f => f.registration_id))];
      
      if (registrationIds.length > 1) {
        Toast.fire('Selecione apenas parcelas da mesma matrícula', '', 'error');
        return;
      }

      // Validar se todas estão em aberto
      const hasPaid = this.selectedFinancials.some(f => f.paid);
      
      if (hasPaid) {
        Toast.fire('Apenas parcelas em aberto podem ser negociadas', '', 'error');
        return;
      }

      this.showRenegotiateModal = true;
    },
    async handleRenegotiateSuccess(data) {
      // Limpar seleção
      this.selectedFinancials = [];
      
      // Recarregar dados do aluno
      await this.getItens();
      
      // Recarregar minutas de acordo
      await this.getAgreementDrafts();
      
      // Mostrar resumo
      this.$swal({
        title: 'Negociação Concluída!',
        html: `
          <p><strong>${data.data.old_installments_count || this.selectedFinancials.length}</strong> parcela(s) antiga(s) baixada(s)</p>
          <p><strong>${data.data.new_installments_count || 0}</strong> nova(s) parcela(s) criada(s)</p>
        `,
        icon: 'success'
      });
    },
    // ==================== SHIPMENT TRACKING ====================
    async loadShipmentTracking() {
      try {
        const { data } = await api.get(`/shipment-tracking/student/${this.id}`);
        
        if (data.data) {
          // Garantir que as datas sejam carregadas corretamente no formato YYYY-MM-DD
          const formatDateFromAPI = (dateValue) => {
            if (!dateValue) return null;
            // Se vier como string, extrair apenas a parte da data (YYYY-MM-DD)
            if (typeof dateValue === 'string') {
              return dateValue.split('T')[0];
            }
            return dateValue;
          };

          this.shipmentTracking = {
            id: data.data.id,
            student_id: data.data.student_id,
            enrollment_date: formatDateFromAPI(data.data.enrollment_date),
            exam_completion_date: formatDateFromAPI(data.data.exam_completion_date),
            document_request_date: formatDateFromAPI(data.data.document_request_date),
            pdf_sent_date: formatDateFromAPI(data.data.pdf_sent_date),
            physical_sent_date: formatDateFromAPI(data.data.physical_sent_date),
            tracking_code: data.data.tracking_code,
            expected_delivery_date: formatDateFromAPI(data.data.expected_delivery_date),
            received_date: formatDateFromAPI(data.data.received_date),
            observations: data.data.observations,
          };
        }
      } catch (error) {
        // Silenciar erro se não houver registro (404 é esperado)
        if (error.response?.status !== 404) {
          console.error('Erro ao carregar acompanhamento:', error);
        }
      }
    },
    async handlerSaveShipmentTracking() {
      try {
        const payload = {
          student_id: this.id,
          enrollment_date: this.shipmentTracking.enrollment_date,
          exam_completion_date: this.shipmentTracking.exam_completion_date,
          document_request_date: this.shipmentTracking.document_request_date,
          pdf_sent_date: this.shipmentTracking.pdf_sent_date,
          physical_sent_date: this.shipmentTracking.physical_sent_date,
          tracking_code: this.shipmentTracking.tracking_code,
          expected_delivery_date: this.shipmentTracking.expected_delivery_date,
          received_date: this.shipmentTracking.received_date,
          observations: this.shipmentTracking.observations,
        };

        let data;
        
        if (this.shipmentTracking.id) {
          // Atualizar
          const response = await api.put(`/shipment-tracking/${this.shipmentTracking.id}`, payload);
          data = response.data;
        } else {
          // Criar
          const response = await api.post(`/shipment-tracking`, payload);
          data = response.data;
        }

        Toast.fire("Sucesso", data.message, "success");
        await this.loadShipmentTracking();
      } catch (error) {
        Toast.fire("Erro", error.response?.data?.message || "Erro ao salvar acompanhamento", "error");
      }
    },
    async handlerDeleteShipmentTracking() {
      if (!confirm('Deseja realmente excluir este acompanhamento de envio?')) {
        return;
      }

      try {
        const { data } = await api.delete(`/shipment-tracking/${this.shipmentTracking.id}`);
        Toast.fire("Sucesso", data.message, "success");
        this.resetShipmentTracking();
      } catch (error) {
        Toast.fire("Erro", error.response?.data?.message || "Erro ao excluir acompanhamento", "error");
      }
    },
    resetShipmentTracking() {
      this.shipmentTracking = {
        id: null,
        student_id: null,
        enrollment_date: null,
        exam_completion_date: null,
        document_request_date: null,
        pdf_sent_date: null,
        physical_sent_date: null,
        tracking_code: null,
        expected_delivery_date: null,
        received_date: null,
        observations: null,
      };
    },
    formatDate(date) {
      if (!date) return '-';
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    applyTabFromQuery() {
      const tab = this.$route.query.tab;
      if (tab === 'documentos' || tab === '2') {
        this.activeTab = 2;
      }
    },
    reset() {
      this.getItens();
    },
  },
  mounted() {
    this.applyTabFromQuery();
    this.getItens();
    this.getImage();
    this.getTeams();
    this.getServiceType();
    this.getPaymentService();
    this.getBookTypes();
    this.getFinancialResponsibles();
    this.getAgreementDrafts();
    this.loadShipmentTracking();

    $('input[name="value"], input[name="fine_amount"], input[name="interest_amount"]').maskMoney();
  },
};
</script>

<style scoped>
.photo {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border: 2px solid #0006;
  margin-bottom: 4px;
  border-radius: 5px;
}

.zoom-on-hover {
  transition: transform 0.3s ease;
}

.zoom-on-hover:hover {
  transform: scale(1.67);
}

.grids-for-contracts {
  display: grid;
  grid-template-columns: 1fr 1fr 100px 120px 1fr 140px 50px;
  gap: 16px;
  padding: 4px 0px;
}

.json-container {
  background-color: #f8f9fa;
  border: 1px solid #ddd;
  padding: 10px;
  border-radius: 5px;
  max-height: 300px;
  overflow-y: auto;
  font-family: monospace;
  white-space: pre-wrap;
}

.d-flex.gap-2 {
  gap: 0.5rem;
}

.required::after {
  content: ' *';
  color: red;
}

/* Miniaturas de documentos emitidos */
.doc-thumbs-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
}

.doc-thumb-card {
  width: 130px;
  border: 1px solid #ddd;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,.08);
  display: flex;
  flex-direction: column;
}

.doc-thumb-preview {
  width: 130px;
  height: 170px;
  overflow: hidden;
  cursor: pointer;
  background: #f5f5f5;
  position: relative;
}

.doc-thumb-preview:hover {
  opacity: 0.85;
}

.doc-thumb-iframe {
  width: 800px;
  height: 1040px;
  border: none;
  transform: scale(0.1625);
  transform-origin: top left;
  pointer-events: none;
}

.doc-thumb-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #c0392b;
  gap: 6px;
}

.doc-thumb-placeholder i {
  font-size: 2.5rem;
}

.doc-thumb-placeholder span {
  font-size: 0.7rem;
  font-weight: bold;
  color: #888;
}

.doc-thumb-footer {
  padding: 4px 6px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  border-top: 1px solid #eee;
}

.doc-thumb-name {
  font-size: 0.6rem;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.doc-thumb-date {
  font-size: 0.55rem;
  color: #888;
}

.doc-thumb-actions {
  display: flex;
  gap: 4px;
  margin-top: 2px;
}

.btn-xs {
  padding: 1px 5px;
  font-size: 0.65rem;
  line-height: 1.4;
  border-radius: 3px;
}
</style>
